/* eslint-disable react/prop-types */
import { useState, useEffect } from 'react';
import {
  Box,
  Container,
  HStack,
} from "@chakra-ui/react";

// form components
import { TextInput } from '../Form/Input/TextInput.jsx';

// form buttons
// import { ButtonQuaternaryWithIcon } from '../Form/Button/ButtonQuaternaryWithIcon.jsx';
import { ButtonPrimaryPlain } from '../Form/Button/ButtonPrimaryPlain.jsx';

// react-hook-form
// import { useForm } from 'react-hook-form';

// graphql
// import { searchQBVendorsByVendorNameLower } from '../graphqlCompnents/Statement/searchQBVendorsByVendorNameLower.jsx';
// import { syncQBVendors } from '../QuickBooks/syncQBVendors.jsx';

// custom components
import { QuickBooksSupplierScrollableBox } from '../reactComponents/QuickBooksSupplierScrollableBox.jsx'

import { normalizeMerchantName } from '../functions/transactionMatching.jsx'

import PropTypes from 'prop-types';

export const VendorMap = (props) => {
  // const { selectedStatement, screenWidth, handleMapVendor, onClose } = props;
  const { 
    handleMapVendor=()=>{}, 
    vendorName='',
    vendors=[], 
    // environment='sandbox', 
    // token='',
    register=()=>{},
    errors={},
    setError=()=>{},
    clearErrors=()=>{},
    setValue=()=>{},
    rowIndex=0,
    showCreateSupplier=true,
    handleNewVendorName=()=>{},
    handleUpdateMerchant=()=>{},
   } = props;

  // console.log('VendorMap props: ', props)

  // clear out any previous search terms
  setValue('searchInput', '') 
  // const screenWidth = 1920;

  const [ searchTerm, setSearchTerm ] = useState('')
  const [ normalizedSearchTerm, setNormalizedSearchTerm ] = useState('')
  // const [ nextToken, setNextToken ] = useState('')
  // const [ nextNextToken, setNextNextToken ] = useState('')
  const [ qbVendorsResults, setQBVendorsResults ] = useState([])

  // const useDebounce = (value, delay) => {
  //   const [debouncedValue, setDebouncedValue] = useState(value);
  
  //   useEffect(() => {
  //     const handler = setTimeout(() => setDebouncedValue(value), delay);
  //     return () => clearTimeout(handler);
  //   }, [value, delay]);
  
  //   return debouncedValue;
  // };
  
  // Inside your component
  // const debouncedSearchTerm = useDebounce(searchTerm, 300); // Debounce by 300ms
  
// normalizedName: "abescateringservices"
// qbDisplayName: "Abe's Catering Services"


  useEffect(() => {
    const searchVendors = async () => {
      // No need to search if vendors are empty
      if (!vendors?.length) return;
  
      let searchResults = [];
  
      if (normalizedSearchTerm?.length < 3) {
        searchResults = vendors.filter(vendor =>
          vendor.normalizedName.startsWith(normalizedSearchTerm.toLowerCase())
        );
      } else {
        searchResults = vendors.filter(vendor =>
          vendor.normalizedName.includes(normalizedSearchTerm.toLowerCase())
        );
      }

      console.log('searchResults: ', searchResults)
  
      const transformedData = transformData(searchResults) || [];
  
      // Update results based on normalizedSearchTerm
      setQBVendorsResults(
        normalizedSearchTerm ? transformedData : transformData(vendors)
      );
    };
  
    searchVendors();
  }, [normalizedSearchTerm, vendors]);

  // Transform function
  const transformData = (data) => {
    return data?.map(item => ({
      id: item.qbId,
      name: item.qbDisplayName,
      value: item.qbDisplayNameLower
    }));
  };

  const resetVendor = () => {
    setValue('searchInput', '');
    setSearchTerm('');
    setNormalizedSearchTerm('');
  }

  // if search term is only one or two cahracters, search filter is begins with
  // if search term is 3 or more characters, serch filter is now contains
  // const updateSearchTerm = (event) => {
  //   if (!event) return
  //   setSearchTerm(event.target.value)
  // }
  const updateSearchTerm = (event) => {
    const value = event.target.value;
    const normalizedValue = normalizeMerchantName(value);
    console.log('normalizedValue: ', normalizedValue)
    if (normalizedValue?.length>0) {
      setValue('searchInput', value); // Update React Hook Form's state
      setSearchTerm(value); // Update local state for other purposes if needed
      setNormalizedSearchTerm(normalizedValue);
    }
  };

  const assignVendor = (vendor) => {
    console.log('assigned vendor: ', vendor)
    setValue('merchantName', vendor.name)
    handleMapVendor(vendor, rowIndex)
    // onClose()
  }


  return(
    <>
      <Container>

        <Box 
          w={'100%'}
          // maxWidth={boxWidth} 
          paddingTop={'25px'}>
          <HStack alignItems="flex-end" height="100%">
            <TextInput
              register={register}
              errors={errors}
              fieldname="searchInput"
              fieldlabel="Search existing QuickBooks suppliers"
              prettyname="Supplier Search"
              placeholder="Enter search term"
              fieldvalue={searchTerm||''}
              onChange={updateSearchTerm}
            />
            <ButtonPrimaryPlain
              type="button"
              onClick={resetVendor}
              height={'40px'}
              name="resetVendor"
              value="Reset"
            />
          </HStack>
        </Box>

        <Box 
          w={'100%'}
          // width={boxWidth} 
          // paddingTop={'25px'}
          >
          {/* <Text pb={'10px'}>All suppliers from QuickBooks</Text> */}
          <QuickBooksSupplierScrollableBox 
            // handleLoadMore={searchNext} 
            handleSelectedObject={assignVendor} 
            handleUpdateMerchant={handleUpdateMerchant}
            items={qbVendorsResults} 
            suggestedMerchantName={vendorName}
            // width={boxWidth} 
            // width={'300px'} 
            width={'100%'} 
            height='285px' 
            register={register} 
            errors={errors} 
            setError={setError} 
            clearErrors={clearErrors} 
            showCreateSupplier={showCreateSupplier}
            setValue={setValue}
            searchTerm={searchTerm}
            handleNewVendorName={handleNewVendorName}
            />
        </Box>

        {/* <Box height={'50px'}></Box> */}

      </Container>
      {/* <Box height={'50px'}></Box> */}
    </>
  )
}

VendorMap.propTypes = {
  handleMapVendor: PropTypes.func,
  vendorName: PropTypes.string,
  vendors: PropTypes.array,
  register: PropTypes.func,
  errors: PropTypes.object,
  setError: PropTypes.func,
  clearErrors: PropTypes.func,
  setValue: PropTypes.func,
  rowIndex: PropTypes.number,
  showCreateSupplier: PropTypes.bool,
  handleNewVendorName: PropTypes.func,
  handleUpdateMerchant: PropTypes.func,
};